(function () {
  window.CodeEditor || (window.CodeEditor = {});

  CodeEditor.init = function () {

    $(".code-editor").each(function (index, e) {
      var editor_div = $(e);
      var id = editor_div.attr("id") || "editor_div_".concat(index);
      editor_div.attr("id", id);
      var RubyMode = window.ace.require("ace/mode/html_ruby").Mode;
      var editor = window.ace.edit(id);
      editor.setTheme("ace/theme/solarized_light");
      editor.session.setMode(new RubyMode());
    });
  };

  CodeEditor.initFormulaEditor = (id, variables) => {
    // ace.require("ace/ext/language_tools");

    let editorInput = $(`#${id}`).siblings(".formula-field");
    variables = variables.filter(function (e) {
      return e;
    });

    let editor = window.ace.edit(id, {});
    editor.setOptions({
      maxLines: 1, // make it 1 line
      autoScrollEditorIntoView: true,
      highlightActiveLine: false,
      printMargin: false,
      showGutter: false,
      theme: "ace/theme/solarized_light",
    });

    editor.on("change", function (event, editor) {
      editorInput.val(editor.getValue().trim());
    });
  };
}).call(this);
